import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import * as yup from "yup";
import { Oval } from "react-loader-spinner";
import { DecodeToken } from "../../DecodeToken";
import {
  rechercherentreprises,
  rechercherentreprisespartenaires,
  recherchersiteparentreprise,
} from "../../services/entreprises/entrepriseRequest";
import {
  rechercherlisteplats,
  rechercherlisteplatsentreprisesite,
} from "../../services/restauratrice/RestauratriceRequest";
import {
  enregistrerpackage,
  rechercherelementsdecombinaison,
  supprimerelementdecombinaison,
} from "../../services/packages/PackageRequest";

const typeDeRepas = [
  { titre: "Entrée", value: "ENTREE" },
  { titre: "Plat de résistance", value: "PLAT" },
  { titre: "Dessert", value: "DESSERT" },
  { titre: "Boisson", value: "BOISSON" },
];

const MODE_TYPE_REPAS = "TYPE_REPAS";
const MODE_REPAS = "REPAS";

function PackagePlatModal(props) {
  const { infoPackage, actualiserListe, modeCombaisonChoisi, restaurantSelected } = props;
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setloading] = useState(false);
  const [listeEntreprise, setListeEntreprise] = useState([]);
  const [entrepriseSelected, setEntrepriseSelected] = useState(null);
  const [listeSite, setListeSite] = useState([]);
  const [siteSelected, setSiteSelected] = useState(null);
  const [listePlats, setListePlats] = useState([]);
  const [modeCombinaison, setModeCombaison] = useState(MODE_TYPE_REPAS);
  const [elementsCombinaison, setElementsCombinaison] = useState([]);

  const isEdition = infoPackage && infoPackage.id !== undefined;

  const afficherEntreprise = () => {
    if (DecodeToken().profil === "ROLE_ADMIN") {
      rechercherentreprises()
        .then((response) => {
          setListeEntreprise(response.data.donnee);
        })
        .catch((error) => {
          console.log("ERROR", error);
        });
    } else {
      rechercherentreprisespartenaires().then((res) => {
        setListeEntreprise(res.data.donnee);
      });
    }
  };

  const afficherSites = (entrepriseId) => {
    if (!entrepriseId) {
      setListeSite([]);
      return;
    }
    recherchersiteparentreprise(entrepriseId).then((res) => {
      setListeSite(res.data.donnee);
    });
  };

  const afficherPlats = (siteId) => {
    if (!siteId) {
      rechercherlisteplats().then((res) => {
        setListePlats(res.data.donnee);
      });
      return;
    }
    rechercherlisteplatsentreprisesite(siteId).then((res) => {
      setListePlats(res.data.donnee);
    });
  };

  const handleChoixEntreprise = (value) => {
    setEntrepriseSelected(value);
    setSiteSelected(null);
    afficherSites(value ? value.id : null);
  };

  const handleChoixSite = (value) => {
    setSiteSelected(value);
    afficherPlats(value ? value.id : null);
  };

  const afficherElementsCombinaison = (combinaisonId) => {
    rechercherelementsdecombinaison(combinaisonId).then((res) => {
      const elements = res.data.donnee ?? [];
      setElementsCombinaison(elements);
      if (elements.length && elements[0].repasId) {
        setModeCombaison(MODE_REPAS);
      } else if (elements.length) {
        setModeCombaison(MODE_TYPE_REPAS);
      }
    });
  };

  useEffect(() => {
    afficherEntreprise();
    afficherPlats(null);
  }, []);

  useEffect(() => {
    if (isEdition) {
      setModeCombaison(infoPackage.modeCombinaison ?? MODE_TYPE_REPAS);
      if (infoPackage.entrepriseId) {
        afficherSites(infoPackage.entrepriseId);
      }
      if (infoPackage.siteId) {
        afficherPlats(infoPackage.siteId);
      }
      afficherElementsCombinaison(infoPackage.id);
    } else {
      setEntrepriseSelected(null);
      setSiteSelected(null);
      setListeSite([]);
      setElementsCombinaison([]);
      setModeCombaison(modeCombaisonChoisi ?? MODE_TYPE_REPAS);
    }
  }, [infoPackage, modeCombaisonChoisi]);

  useEffect(() => {
    if (isEdition && infoPackage.entrepriseId && listeEntreprise.length) {
      const entreprise = listeEntreprise.find(
        (item) => String(item.id) === String(infoPackage.entrepriseId)
      );
      setEntrepriseSelected(
        entreprise ?? {
          id: infoPackage.entrepriseId,
          raisonSociale: infoPackage.entreprise,
        }
      );
    }
  }, [isEdition, infoPackage.entrepriseId, infoPackage.entreprise, listeEntreprise]);

  useEffect(() => {
    if (isEdition && infoPackage.siteId && listeSite.length) {
      const site = listeSite.find(
        (item) => String(item.id) === String(infoPackage.siteId)
      );
      setSiteSelected(
        site ?? { id: infoPackage.siteId, nom: infoPackage.site }
      );
    }
  }, [isEdition, infoPackage.siteId, infoPackage.site, listeSite]);

  const ligneVide = () =>
    modeCombinaison === MODE_REPAS
      ? { repasId: "", quantite: "" }
      : { typeRepas: "", quantite: "" };

  const initialValues = {
    id: isEdition ? infoPackage.id : "",
    nom: isEdition && infoPackage.nom !== undefined ? infoPackage.nom : "",
    prix: isEdition ? infoPackage.prix : "",
    listeCombinaisonFormuler:
      isEdition && elementsCombinaison.length
        ? elementsCombinaison
        : [ligneVide()],
  };

  const validationSchema = yup.object().shape({
    prix: yup.number().required("Veuillez saisir un prix"),
    listeCombinaisonFormuler: yup
      .array()
      .of(
        modeCombinaison === MODE_REPAS
          ? yup.object().shape({
              repasId: yup.string().required("Choisir un plat"),
              quantite: yup
                .number()
                .typeError("Nombre requis")
                .positive("Doit être supérieur à 0")
                .required("Quantité requise"),
            })
          : yup.object().shape({
              typeRepas: yup.string().required("Choisir un type"),
              quantite: yup
                .number()
                .typeError("Nombre requis")
                .positive("Doit être supérieur à 0")
                .required("Quantité requise"),
            })
      )
      .min(1, "Ajoutez au moins une ligne"),
  });

  const resetLocalState = () => {
    setErrorMessage("");
  };

  const handleSupprimerElement = (item, index, remove) => {
    if (item.id !== undefined) {
      supprimerelementdecombinaison(item.id)
        .then(() => {
          remove(index);
        })
        .catch(() => {
          setErrorMessage(
            "Une erreur s'est produite, impossible de supprimer cet élément"
          );
        });
    } else {
      remove(index);
    }
  };

  const onSubmitPackage = (values, { resetForm }) => {
    setloading(true);
    setErrorMessage("");

    const dataToSave = {
      ...(isEdition ? { combinaisonId: values.id } : {}),
      nom: values.nom,
      prix: values.prix,
      ...(entrepriseSelected ? { entrepriseId: entrepriseSelected.id } : {}),
      ...(siteSelected ? { siteId: siteSelected.id } : {}),
      modeCombinaison: modeCombinaison,
      listeCombinaisonFormuler: values.listeCombinaisonFormuler.map((item) =>
        modeCombinaison === MODE_REPAS
          ? {
              ...(item.id !== undefined ? { id: item.id } : {}),
              repasId: item.repasId,
              quantite: parseInt(item.quantite, 10),
            }
          : {
              ...(item.id !== undefined ? { id: item.id } : {}),
              typeRepas: item.typeRepas,
              quantite: parseInt(item.quantite, 10),
            }
      ),
      restaurantId: restaurantSelected?.id,
    };

    enregistrerpackage(dataToSave)
      .then(() => {
        setloading(false);
        actualiserListe();
        resetForm();
        resetLocalState();
        document.getElementById("closePackagePlatModal").click();
      })
      .catch((error) => {
        setloading(false);
        if (error && error.response) {
          setErrorMessage(error.response.data.donnee);
        } else {
          setErrorMessage(
            "Une erreur s'est produite, impossible d'enregistrer le package"
          );
        }
      });
  };

  return (
    <div
      className="modal fade"
      id="packagePlatModal"
      tabIndex={-1}
      aria-labelledby="packagePlatModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content bg-rose">
          <div className="w-100 d-flex px-3 align-items-center justify-content-between mt-2">
            <h6
              className="text-center pt-4"
              style={{ fontSize: 18, fontWeight: "bold" }}
            >
              {isEdition ? "Modifier le package" : "Créer un package"}
            </h6>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={resetLocalState}
            ></button>
          </div>
          <div className="modal-body">
            <Formik
              initialValues={initialValues}
              enableReinitialize
              validationSchema={validationSchema}
              onSubmit={onSubmitPackage}
            >
              {({ values }) => (
                <Form>
                  <div className="mb-3">
                    <label className="mb-1">Nom du package (optionnel)</label>
                    <Field
                      type="text"
                      name="nom"
                      placeholder="Ex: Déjeuner"
                      className="form-control"
                    />
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <Autocomplete
                        disablePortal
                        options={listeEntreprise}
                        getOptionLabel={(option) =>
                          option.raisonSociale ?? option
                        }
                        isOptionEqualToValue={(option, value) =>
                          String(option.id) === String(value.id)
                        }
                        value={entrepriseSelected}
                        onChange={(event, value) =>
                          handleChoixEntreprise(value)
                        }
                        size="small"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            className="bg-white"
                            label="Entreprise"
                          />
                        )}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <Autocomplete
                        disablePortal
                        options={listeSite}
                        getOptionLabel={(option) => option.nom ?? option}
                        isOptionEqualToValue={(option, value) =>
                          String(option.id) === String(value.id)
                        }
                        value={siteSelected}
                        onChange={(event, value) => handleChoixSite(value)}
                        disabled={!entrepriseSelected}
                        size="small"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            className="bg-white"
                            label="Site de l'entreprise"
                          />
                        )}
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <div className="input-group mb-3">
                      <Field
                        type="text"
                        placeholder="Prix"
                        name="prix"
                        className="form-control loginborderright"
                      />
                      <div className="input-group-text bg-white">FCFA</div>
                    </div>
                    <div className="text-danger">
                      <ErrorMessage name="prix"></ErrorMessage>
                    </div>
                  </div>

                  <label className="mb-2 fw-bold">Composition du package</label>
                  <FieldArray name="listeCombinaisonFormuler">
                    {({ push, remove }) => (
                      <div>
                        {values.listeCombinaisonFormuler.map((item, index) => {
                          const dejaChoisis = values.listeCombinaisonFormuler
                            .filter((_, i) => i !== index)
                            .map((composant) =>
                              modeCombinaison === MODE_REPAS
                                ? composant.repasId
                                : composant.typeRepas
                            );

                          return (
                            <div
                              className="d-flex align-items-start gap-2 mb-2"
                              key={index}
                            >
                              <div style={{ flex: 2 }}>
                                {modeCombinaison === MODE_REPAS ? (
                                  <Field
                                    as="select"
                                    name={`listeCombinaisonFormuler.${index}.repasId`}
                                    className="form-control loginborderright cursor"
                                  >
                                    <option disabled value="">
                                      Plat
                                    </option>
                                    {listePlats.map((plat, i) => (
                                      <option
                                        value={plat.id}
                                        key={i}
                                        disabled={dejaChoisis.includes(
                                          String(plat.id)
                                        )}
                                      >
                                        {plat.designation}
                                      </option>
                                    ))}
                                  </Field>
                                ) : (
                                  <Field
                                    as="select"
                                    name={`listeCombinaisonFormuler.${index}.typeRepas`}
                                    className="form-control loginborderright cursor"
                                  >
                                    <option disabled value="">
                                      Type de repas
                                    </option>
                                    {typeDeRepas.map((type, i) => (
                                      <option
                                        value={type.value}
                                        key={i}
                                        disabled={dejaChoisis.includes(
                                          type.value
                                        )}
                                      >
                                        {type.titre}
                                      </option>
                                    ))}
                                  </Field>
                                )}
                                <div className="text-danger">
                                  <ErrorMessage
                                    name={
                                      modeCombinaison === MODE_REPAS
                                        ? `listeCombinaisonFormuler.${index}.repasId`
                                        : `listeCombinaisonFormuler.${index}.typeRepas`
                                    }
                                  ></ErrorMessage>
                                </div>
                              </div>
                              <div style={{ flex: 1 }}>
                                <Field
                                  type="text"
                                  placeholder="Quantité"
                                  name={`listeCombinaisonFormuler.${index}.quantite`}
                                  className="form-control"
                                />
                                <div className="text-danger">
                                  <ErrorMessage
                                    name={`listeCombinaisonFormuler.${index}.quantite`}
                                  ></ErrorMessage>
                                </div>
                              </div>
                              <button
                                type="button"
                                className="btn text-danger"
                                disabled={
                                  values.listeCombinaisonFormuler.length === 1
                                }
                                onClick={() =>
                                  handleSupprimerElement(item, index, remove)
                                }
                              >
                                <i className="fa fa-trash-alt"></i>
                              </button>
                            </div>
                          );
                        })}
                        <button
                          type="button"
                          className="btn btn-sm mb-3"
                          style={{
                            color: "#CE5D1D",
                            border: "1px solid #CE5D1D",
                          }}
                          disabled={
                            modeCombinaison === MODE_TYPE_REPAS &&
                            values.listeCombinaisonFormuler.length >=
                              typeDeRepas.length
                          }
                          onClick={() => push(ligneVide())}
                        >
                          <i className="fa fa-plus me-1"></i>
                          Ajouter{" "}
                          {modeCombinaison === MODE_REPAS
                            ? "un plat"
                            : "un type de repas"}
                        </button>
                      </div>
                    )}
                  </FieldArray>

                  {errorMessage !== "" ? (
                    <p className="mt-2 text-danger text-center">
                      {errorMessage}
                    </p>
                  ) : null}

                  <div className="row justify-content-center mt-3">
                    <Oval
                      width={40}
                      height={40}
                      color="#CE5D1D"
                      visible={loading}
                    />
                    {!loading && (
                      <button
                        type="submit"
                        className="btn btn-rose text-white w-auto px-4"
                      >
                        ENREGISTRER
                      </button>
                    )}
                  </div>
                </Form>
              )}
            </Formik>
            <button
              type="button"
              id="closePackagePlatModal"
              data-bs-dismiss="modal"
              hidden
            ></button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PackagePlatModal;
